import Yup from 'helpers/customYup'
import formModels from './Models';
import {
    EMPLOYMENT_STATUS,
    OCCUPATION_ROLE,
    OCCUPATION_INDUSTRY,
    RESIDENTIAL_STATUS,
    SOURCE_OF_FUND,
    INVESTMENT_OBJECTIVES,
    TAX_ID_REASON
} from 'constants/Options/options'

const { formField } = formModels;

// List validation <=> list step
const validationSchema = [
    Yup.object().shape({
        [formField.applicant_verification_id.name]: Yup.object().shape({
            [formField.applicant_verification_id.applicant_nationality.originName]: Yup.mixed().checkRequired(),
            [formField.applicant_verification_id.id_type.originName]: Yup.mixed().checkRequired(),
            [formField.applicant_verification_id.country_of_residence.originName]: Yup.mixed().checkRequired(),
            [formField.applicant_verification_id.pass_port.originName]: Yup.mixed().checkRequired().checkFile()
        })
    }),
    Yup.object().shape({}),
    Yup.object().shape({
        [formField.personal_information.name]: Yup.object().shape({
            [formField.personal_information.eng_given_name.originName]: Yup.mixed().checkRequired().checkName().checkMaxLength(100),
            [formField.personal_information.eng_middle_name.originName]: Yup.mixed().checkName().checkMaxLength(100),
            [formField.personal_information.eng_sur_name.originName]: Yup.mixed().checkRequired().checkName().checkMaxLength(100),
            [formField.personal_information.chinese_name.originName]: Yup.mixed().checkMaxLength(255),
            [formField.personal_information.gender.originName]: Yup.mixed().checkRequired(),
            [formField.personal_information.id_number.originName]: Yup.mixed().checkRequired().checkIdNumber(),
            [formField.personal_information.dob.originName]: Yup.mixed().checkRequired().checkEnoughAge(),
            [formField.personal_information.region.originName]: Yup.mixed().checkRequired().checkAddress().checkMaxLength(255),
            [formField.personal_information.house_number.originName]: Yup.mixed().checkMaxLength(255),
            [formField.personal_information.street_name.originName]: Yup.mixed().checkRequired().checkMaxLength(255),
            [formField.personal_information.city_name.originName]: Yup.mixed().checkRequired().checkMaxLength(255),
            [formField.personal_information.province_name.originName]: Yup.mixed().checkRequired().checkMaxLength(255),
            [formField.personal_information.zip_code.originName]: Yup.mixed().checkMaxLength(255),
            [formField.personal_information.correspondence_address_document.originName]: Yup.mixed().checkFile(),
            [formField.personal_information.mobile_number.originName]: Yup.mixed().checkRequired().checkPhone(),
            [formField.personal_information.email_address.originName]: Yup.mixed().checkRequired().checkEmail(),
            [formField.personal_information.education.originName]: Yup.mixed().checkRequired()
        })
    }),
    Yup.object().shape({
        [formField.employment_information.name]: Yup.object().shape({
            [formField.employment_information.employment_status.originName]: Yup.mixed().checkRequired(),
            [formField.employment_information.employment_status_desc.originName]: Yup.mixed().when(
                formField.employment_information.employment_status.originName, (employmentStatus, schema) => {
                    return employmentStatus === EMPLOYMENT_STATUS.OTHER ? schema.checkRequired().checkMaxLength(200) : schema;
                }
            ),
            [formField.employment_information.employer_name.originName]: Yup.mixed().when(
                formField.employment_information.employment_status.originName, (employmentStatus, schema) => {
                    return employmentStatus !== EMPLOYMENT_STATUS.RETIRED ? schema.checkRequired('lang_please_enter_full_company_name').checkMaxLength(200) : schema;
                }
            ),
            [formField.employment_information.occupation_role.originName]: Yup.mixed().when(
                formField.employment_information.employment_status.originName, (employmentStatus, schema) => {
                    return employmentStatus !== EMPLOYMENT_STATUS.RETIRED ? schema.checkRequired() : schema;
                }
            ),
            [formField.employment_information.occupation_role_desc.originName]: Yup.mixed().when(
                [formField.employment_information.employment_status.originName, formField.employment_information.occupation_role.originName],
                (employmentStatus, occupationRole, schema) => {
                    return employmentStatus === EMPLOYMENT_STATUS.RETIRED || occupationRole !== OCCUPATION_ROLE.OTHER
                        ? schema
                        : schema.checkRequired().checkMaxLength(200);
                }
            ),
            [formField.employment_information.occupation_industry.originName]: Yup.mixed().when(
                formField.employment_information.employment_status.originName, (employmentStatus, schema) => {
                    return employmentStatus !== EMPLOYMENT_STATUS.RETIRED ? schema.checkRequired() : schema;
                }
            ),
            [formField.employment_information.occupation_industry_desc.originName]: Yup.mixed().when(
                [formField.employment_information.employment_status.originName, formField.employment_information.occupation_industry.originName],
                (employmentStatus, occupationIndustry, schema) => {
                    return employmentStatus === EMPLOYMENT_STATUS.RETIRED || occupationIndustry !== OCCUPATION_INDUSTRY.OTHERS
                        ? schema
                        : schema.checkRequired().checkMaxLength(200);
                }
            ),
            [formField.employment_information.working_duration.originName]: Yup.mixed().when(
                formField.employment_information.employment_status.originName, (employmentStatus, schema) => {
                    return employmentStatus !== EMPLOYMENT_STATUS.RETIRED ? schema.checkRequired() : schema;
                }
            ),
        })
    }),
    Yup.object().shape({
        [formField.personal_financial_information.name]: Yup.object().shape({
            [formField.personal_financial_information.annual_income.originName]: Yup.mixed().checkRequired(),
            [formField.personal_financial_information.net_asset_value.originName]: Yup.mixed().checkRequired(),
            [formField.personal_financial_information.housing_status.originName]: Yup.mixed().checkRequired(),
            [formField.personal_financial_information.housing_status_desc.originName]: Yup.mixed().when(
                formField.personal_financial_information.housing_status.originName, (residentialStatus, schema) => {
                    return residentialStatus === RESIDENTIAL_STATUS.OTHER ? schema.checkRequired().checkMaxLength(200) : schema;
                }
            ),
            [formField.personal_financial_information.source_of_fund.originName]: Yup.mixed().checkRequired(),
            [formField.personal_financial_information.source_of_fund_desc.originName]: Yup.mixed().when(
                formField.personal_financial_information.source_of_fund.originName, (sourceOfFund, schema) => {
                    return sourceOfFund.includes(SOURCE_OF_FUND.OTHER) ? schema.checkRequired().checkMaxLength(200) : schema;
                }
            ),
            [formField.personal_financial_information.liquid_net_worth.originName]: Yup.mixed().checkRequired()
        }),
        [formField.invesment_exp.name]: Yup.object().shape({
            [formField.invesment_exp.stock.originName]: Yup.mixed().checkRequired(),
            [formField.invesment_exp.cbbc.originName]: Yup.mixed().checkRequired(),
            [formField.invesment_exp.derivatives.originName]: Yup.mixed().checkRequired(),
            [formField.invesment_exp.futures.originName]: Yup.mixed().checkRequired(),
            [formField.invesment_exp.options_warrants.originName]: Yup.mixed().checkRequired(),
            [formField.invesment_exp.forex.originName]: Yup.mixed().checkRequired(),
            [formField.invesment_exp.commodity.originName]: Yup.mixed().checkRequired(),
            [formField.invesment_exp.other.originName]: Yup.mixed().checkMaxLength(200),
            [formField.invesment_exp.other_period.originName]: Yup.mixed().when(
                formField.invesment_exp.other.originName, (otherInvestmentExp, schema) => {
                    return otherInvestmentExp ? schema.checkRequired() : schema;
                }
            )
        }),
        [formField.investment_objectives_and_risk_tolerance.name]: Yup.object().shape({
            [formField.investment_objectives_and_risk_tolerance.investment_objectives.originName]: Yup.mixed().checkRequired(),
            [formField.investment_objectives_and_risk_tolerance.investment_objectives_desc.originName]: Yup.mixed().when(
                formField.investment_objectives_and_risk_tolerance.investment_objectives.originName, (investmentObjectives, schema) => {
                    return investmentObjectives === INVESTMENT_OBJECTIVES.OTHER ? schema.checkRequired().checkMaxLength(200) : schema;
                }
            ),
            [formField.investment_objectives_and_risk_tolerance.investment_time.originName]: Yup.mixed().checkRequired(),
            [formField.investment_objectives_and_risk_tolerance.investment_volume.originName]: Yup.mixed().checkRequired(),
            [formField.investment_objectives_and_risk_tolerance.risk_tolerance.originName]: Yup.mixed().checkRequired()
        }),
        [formField.derivative_awareness.name]: Yup.mixed().checkDerivativesAwarenessAssessment()
    }),
    Yup.object().shape({
        [formField.identity_disclosure.name]: Yup.object().shape({
            [formField.identity_disclosure.licensed_person_comp_name.originName]: Yup.mixed().when(
                formField.identity_disclosure.registered_securities_futures.originName, (registeredSecuritiesFutures, schema) => {
                    return registeredSecuritiesFutures ? schema.checkRequired().checkMaxLength(200) : schema;
                }
            ),
            [formField.identity_disclosure.relationship_desc.originName]: Yup.mixed().when(
                formField.identity_disclosure.related_to_public_function.originName, (relatedToPublicFunction, schema) => {
                    return relatedToPublicFunction ? schema.checkRequired().checkMaxLength(300) : schema;
                }
            ),
            [formField.identity_disclosure.comp_officer_name.originName]: Yup.mixed().when(
                formField.identity_disclosure.related_to_magpie.originName, (relatedToMagpie, schema) => {
                    return relatedToMagpie ? schema.checkRequired().checkMaxLength(100) : schema;
                }
            ),
            [formField.identity_disclosure.comp_officer_relationship.originName]: Yup.mixed().when(
                formField.identity_disclosure.related_to_magpie.originName, (relatedToMagpie, schema) => {
                    return relatedToMagpie ? schema.checkRequired().checkMaxLength(300) : schema;
                }
            ),
            [formField.identity_disclosure.spouse_name.originName]: Yup.mixed().when(
                formField.identity_disclosure.spouse_margin.originName, (spouseMargin, schema) => {
                    return spouseMargin ? schema.checkRequired().checkMaxLength(100) : schema;
                }
            ),
            [formField.identity_disclosure.spouse_account_number.originName]: Yup.mixed().when(
                formField.identity_disclosure.spouse_margin.originName, (spouseMargin, schema) => {
                    return spouseMargin ? schema.checkRequired().checkMaxLength(20) : schema;
                }
            ),
            [formField.identity_disclosure.client_name.originName]: Yup.mixed().when(
                formField.identity_disclosure.control_magpie_voting.originName, (controlMagpieVoting, schema) => {
                    return controlMagpieVoting ? schema.checkRequired().checkMaxLength(100) : schema;
                }
            ),
            [formField.identity_disclosure.client_account_number.originName]: Yup.mixed().when(
                formField.identity_disclosure.control_magpie_voting.originName, (controlMagpieVoting, schema) => {
                    return controlMagpieVoting ? schema.checkRequired().checkMaxLength(20) : schema;
                }
            )
        }),
        [formField.tax_information.name]: Yup.array().of(Yup.object().shape({
            [formField.tax_information.tax_country.originName]: Yup.mixed().checkRequired(),
            [formField.tax_information.tax_id.originName]: Yup.mixed().when(
                formField.tax_information.is_there_taxid.originName, (isThereTaxId, schema) => {
                    return isThereTaxId ? schema.checkRequired().checkIdNumber() : schema;
                }
            ),
            [formField.tax_information.taxid_reason.originName]: Yup.mixed().when(
                formField.tax_information.is_there_taxid.originName, (isThereTaxId, schema) => {
                    return isThereTaxId ? schema : schema.checkRequired()
                }
            ),
            [formField.tax_information.taxid_reason_desc.originName]: Yup.mixed().when(
                [formField.tax_information.is_there_taxid.originName, formField.tax_information.taxid_reason.originName],
                (isThereTaxId, taxIdReason, schema) => {
                    return isThereTaxId || taxIdReason !== TAX_ID_REASON.REASON_B ? schema : schema.checkRequired().checkMaxLength(300)
                }
            )
        })),
        [formField.us_person_info.name]: Yup.object().shape({
            [formField.us_person_info.country_of_citizenship.originName]: Yup.mixed().when(
                formField.us_person_info.are_you_us_person.originName, (isUSPerson, schema) => {
                    return isUSPerson ? schema : schema.checkRequired()
                }
            ),
            [formField.us_person_info.country_of_tax_treaty_benefits.originName]: Yup.mixed().when(
                formField.us_person_info.are_you_us_person.originName, (isUSPerson, schema) => {
                    return isUSPerson ? schema : schema.checkRequired()
                }
            ),
            [formField.us_person_info.taxpayer_id.originName]: Yup.mixed().when(
                formField.us_person_info.are_you_us_person.originName, (isUSPerson, schema) => {
                    return isUSPerson ? schema.checkRequired().checkTaxPayerId() : schema
                }
            ),
        })
    }),
    Yup.object().shape({}),
    Yup.object().shape({
        [formField.risk_disclosure.name]: Yup.mixed().checkRiskDisclosureAndDeclarationSignature()
    }),
    Yup.object().shape({
        [formField.e_signature.name]: Yup.mixed().checkRequired()
    }),
]

// const validationSchema1 = []

export default validationSchema